import { useState } from 'react';
import AppShell from '../components/AppShell';
import Manufacturers from './master/Manufacturers';
import Categories from './master/Categories';
import Models from './master/Models';
import Lookups from './master/Lookups';
import InspectionItems from './master/InspectionItems';
import InspectionTypes from './master/InspectionTypes';
import Branches from './master/Branches';
import Users from './master/Users';

const tabs = [
  { key: 'branches', title: 'المزادات' },
  { key: 'users', title: 'المستخدمون' },
  { key: 'manufacturers', title: 'الشركات' },
  { key: 'categories', title: 'الفئات' },
  { key: 'models', title: 'الموديلات' },
  { key: 'lookups', title: 'القوائم الثابتة' },
  { key: 'types', title: 'أنواع الفحص' },
  { key: 'items', title: 'بنود الفحص' },
];

export default function MasterLayout() {
  const [tab, setTab] = useState('branches');

  return (
    <AppShell title="إعدادات الترميز">
      <div className="min-w-0 rounded-2xl border bg-white p-3">
        <div className="mb-4 flex flex-wrap gap-2 border-b pb-3">
          {tabs.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`rounded-lg px-3 py-2 ${tab === t.key ? 'bg-primary text-white' : 'bg-slate-100'}`}
            >
              {t.title}
            </button>
          ))}
        </div>

        <div className="min-w-0">
          {tab === 'branches' && <Branches />}
          {tab === 'users' && <Users />}
          {tab === 'manufacturers' && <Manufacturers />}
          {tab === 'categories' && <Categories />}
          {tab === 'models' && <Models />}
          {tab === 'lookups' && <Lookups />}
          {tab === 'types' && <InspectionTypes />}
          {tab === 'items' && <InspectionItems />}
        </div>
      </div>
    </AppShell>
  );
}
